// extracted by mini-css-extract-plugin
export default {"title":"StandardCard_title__-6FB1","icon":"StandardCard_icon__QUQ6a","active":"StandardCard_active__xXqzH"};